import type {components} from "~/types/api-types";
import React from "react";

type OpeningDto = components["schemas"]["OpeningHourResponse"]

interface Props {
  active?: boolean;
  title: string;
  dates: OpeningDto[];
}

export default function OpeningHourCard({ active, title, dates }: Props) {
  const day = (new Date().getDay() + 7 - 1) % 7;
  return (
    <>
      <div className="w-full rounded-[32px] bg-white p-[40px] shadow-[0_4px_16px_0_rgba(0,0,0,0.08)]">
        <div className="max-h-2">
          {active && (
            <span className="btn btn-secondary btn-slim">Aktuální</span>
          )}
        </div>
        <div className="mb-10 mt-20 flex w-full flex-col items-center lg:mb-32 lg:mt-32">
          <span className="h3 mb-12 text-primary">{title}</span>
          {dates.map((date, idx) => {
            return (
              <OpeningHour
                dayName={getDayName(date.day)}
                from={date.from}
                to={date.to}
                key={idx}
                active={active && day == idx}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}

function OpeningHour({
                       dayName,
                       from,
                       to,
                       active,
                     }: {
  dayName: string;
  from?: string;
  to?: string;
  active?: boolean;
}) {
  return (
    <div
      className={
        "flex w-10/12 justify-between rounded-full px-8 py-2 text-gray-700 md:w-6/12" +
        (active ? " bg-[#4CAF5014] font-bold text-success-primary" : "")
      }
    >
      <span>{dayName}</span>
      {from != null && to != null ? <span>{from}–{to}</span> : <span>zavřeno</span>}
    </div>
  );
}

export function getDayName(dayName: DayName): string {
  switch (dayName) {
    case "MONDAY":
      return "pondělí";
    case "TUESDAY":
      return "úterý";
    case "WEDNESDAY":
      return "středa";
    case "THURSDAY":
      return "čtvrtek";
    case "FRIDAY":
      return "pátek";
    case "SATURDAY":
      return "sobota";
    case "SUNDAY":
      return "neděle"
  }
}

type Season = "WINTER" | "SUMMER";
type DayName = "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";

export function getTitle(season: Season): string {
  if (season === "SUMMER") return "Letní provoz"
  else return "Zimní provoz"
}
